export default "__VITE_ASSET__CN79j1SD__"